import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { waLink } from '../../config';

const WhatsAppFloat: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [labelVisible, setLabelVisible] = useState(false);
  const [bottomOffset, setBottomOffset] = useState(28);

  // El botón sube cuando el footer entra en pantalla, o cuando alguna página
  // muestra su propia barra fija inferior (ver [data-fixed-bottom-bar] en
  // PilotProgramPage), para no quedar tapado ni encima de ese elemento.
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 300 && !visible) {
        setVisible(true);
        setTimeout(() => setLabelVisible(true), 600);
      }
      let maxOverlap = 0;
      const footerEl = document.querySelector('footer');
      if (footerEl) {
        maxOverlap = Math.max(maxOverlap, window.innerHeight - footerEl.getBoundingClientRect().top);
      }
      document.querySelectorAll('[data-fixed-bottom-bar]').forEach((bar) => {
        maxOverlap = Math.max(maxOverlap, window.innerHeight - bar.getBoundingClientRect().top);
      });
      setBottomOffset(maxOverlap > 0 ? maxOverlap + 20 : 28);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          transition={{ type: 'spring', stiffness: 300, damping: 22 }}
          style={{
            position: 'fixed',
            bottom: `${bottomOffset}px`,
            right: '28px',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <AnimatePresence>
            {labelVisible && (
              <motion.div
                initial={{ opacity: 0, x: 10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                transition={{ duration: 0.3 }}
                style={{
                  background: '#fff',
                  color: '#111',
                  padding: '8px 14px',
                  borderRadius: '12px',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                }}
                onClick={() => window.open(waLink(), '_blank')}
              >
                ¿Preguntas? Escríbenos
              </motion.div>
            )}
          </AnimatePresence>

          <motion.a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            animate={{
              boxShadow: [
                '0 0 0px rgba(37, 211, 102, 0)',
                '0 0 20px rgba(37, 211, 102, 0.6)',
                '0 0 0px rgba(37, 211, 102, 0)',
              ],
            }}
            transition={{
              boxShadow: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
            }}
            style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: '#25D366',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              flexShrink: 0,
            }}
            aria-label="Contactar por WhatsApp"
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.52 3.48A11.84 11.84 0 0012.05.02C5.46.02.07 5.4.07 12a11.93 11.93 0 001.6 5.99L0 24l6.18-1.62A11.92 11.92 0 0012.05 24C18.64 24 24 18.6 24 12a11.84 11.84 0 00-3.48-8.52zM12.05 22a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.72.97.99-3.62-.24-.38A9.93 9.93 0 012.07 12C2.07 6.5 6.54 2 12.05 2a9.95 9.95 0 017.06 2.93A9.93 9.93 0 0122 12.05C22 17.54 17.54 22 12.05 22zm5.45-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07a8.17 8.17 0 01-2.4-1.48 9.04 9.04 0 01-1.66-2.07c-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z"/>
            </svg>
          </motion.a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppFloat;
